<template>
  <div class="adv_order_transporters_multiple">
    <div v-for="transporter in getTransporters" :key="transporter.transporter_id" class="custom-control custom-radio">
      <input name="transport_id"
             v-bind:value="transporter.transporter_id"
             @input="$emit('input', $event.target.value)"
             @click="onClickTransporter($event)"
             @change="onChangeTransporter($event)"
             type="radio"
             :id="'courierRadio' + transporter.transporter_id"
             class="custom-control-input"
             :disabled="transporterSmartPointsApiError(transporter)"
             v-model="selectedTransporter"
      >
      <label class="custom-control-label transporter_label" :for="'courierRadio' + transporter.transporter_id">
        {{ transporter.name }}
        <small v-if="!getIsExternalTransporterCost(transporter.transporter_id)">
          <em v-html=" '(' + (transporter.transportationCost * getSelectedCurrency.rate).toFixed(2) + getSelectedCurrency.symbol + ')' "/>
        </small>
      </label>

      <AdvOrderTransportersExternal v-if="shouldDisplayTransportersExternal(transporter.transporter_id)" />

     <SmartPoints v-if="getSmartPointsEnableForTransporter(transporter)" :transporter="transporter" />
    </div>
  </div>
</template>

<script>
import SmartPointMixin from './SmartPoint/SmartPointMixin'
import { mapGetters, mapMutations } from 'vuex'
import { filter } from 'lodash-es'
import SmartPoints from './SmartPoint/SmartPoints.vue'
import AdvOrderTransportersExternal from './AdvOrderTransportersExternal.vue'

export default {
  name: 'AdvOrderTransportersMultiple',
  components: { SmartPoints, AdvOrderTransportersExternal },
  mixins: [SmartPointMixin],
  computed: {
    ...mapGetters([
      'getTransporters',
      'getSelectedCurrency',
      'getIsExternalTransporterCost',
      'getSelectedTransporterId'
    ])
  },
  data () {
    return {
      selectedTransporter: null
    }
  },
  watch: {
    selectedTransporter (val) {
      this.checkTransporterSmartPointsApiError()
    },
    getTransporters (val) {
      this.checkTransportersDataChange()
    }
  },
  mounted () {
    this.checkTransportersDataChange()
  },
  methods: {
    ...mapMutations([
      'setSelectedTransporterId',
      'setSelectedTransporterExternalRate'
    ]),
    async onClickTransporter (event) {
      this.setSelectedTransporterId(event.target.value)
      await this.smartPointUncheck()
      if (!this.getIsSmartPointOnlyTransporter) {
        return
      }
      this.setSmartPointIsSelected(true)
      await this.resolveDefaultMapInitialization()
    },
    onChangeTransporter ($event) {
      this.$emit('change', $event)
      this.setSelectedSmartPoint(null)
      this.setSelectedTransporterExternalRate(null)
    },
    checkTransportersDataChange () {
      if (this.getTransporters.length === 0) {
        return
      }

      if (!this.selectedTransporter) {
        this.$emit('set-input', this.getTransporters[0].transporter_id)
        this.selectedTransporter = this.getTransporters[0].transporter_id
        this.setSelectedTransporterId(this.getTransporters[0].transporter_id)
        return
      }

      const transporterExist = this.getTransporters.find(item => item.transporter_id === this.selectedTransporter)
      if (!transporterExist) {
        this.$emit('set-input', this.getTransporters[0].transporter_id)
        this.selectedTransporter = this.getTransporters[0].transporter_id
        this.setSelectedTransporterId(this.getTransporters[0].transporter_id)
      }
    },
    checkTransporterSmartPointsApiError () {
      if (this.getSelectedTransporterSmartPointsApiError && this.getSelectedTransporterObject.deliveryOptionType === '2') {
        const selectedTransporter = filter(this.getTransporters, (transporter) => {
          return !this.transporterSmartPointsApiError(transporter)
        })
        if (selectedTransporter.length === 0) {
          return
        }
        this.selectedTransporter = selectedTransporter[0].transporter_id
        this.$emit('set-input', selectedTransporter[0].transporter_id)
      }
    },
    shouldDisplayTransportersExternal (transporterId) {
      return this.getIsExternalTransporterCost(transporterId) && Number(transporterId) === Number(this.getSelectedTransporterId)
    }
  }
}
</script>
